// Per-run site table over the filtered selection: every deficiency run with
// the crashes that fall within the study buffer of it. Clicking a row flies
// the map to that segment.
import React from 'react';

const fmtMp = (v) => (v === null || v === undefined ? '—' : v.toFixed(3));

// The "worst" column means something different per analysis
const worstLabel = (analysis) => ({
  SSD: 'Worst (mph)', PSD: 'Worst (mph)', GLR: 'Glare (min/yr)',
  FSA: 'Cross slope (%)', HCA: 'Score (%)', GRW: 'Embank. ht (ft)',
  ISD: 'Required ISD (ft)', ALL: 'Worst',
}[analysis] || 'Worst');

export default function SitesTable({ sites, analysis, onFocus }) {
  if (!sites?.length) return <div className="safety-muted">No {analysis} deficiency runs in the current selection.</div>;
  const showAnalysis = analysis === 'ALL';
  return (
    <div className="safety-table-scroll">
      <table className="safety-table safety-table-clickable">
        <thead>
          <tr>
            {showAnalysis && <th>Analysis</th>}
            <th>Milepost</th><th>Dir</th><th>Stations</th><th>{worstLabel(analysis)}</th>
            <th>Severity</th><th>Length (mi)</th>
            <th>Crashes ±0.1 mi</th><th>Non-animal</th><th>Fatal+Injury</th>
          </tr>
        </thead>
        <tbody>
          {sites.map((s) => (
            <tr
              key={`${s.analysis || analysis}-${s.direction}-${s.id}`}
              className={s.nonAnimalCount > 0 ? 'safety-row-hit' : ''}
              onClick={() => onFocus && onFocus({
                bounds: (s.coords || []).filter((p) => p[0] != null),
                lat: s.coords?.[0]?.[0], lng: s.coords?.[0]?.[1],
                key: `site-${s.analysis || analysis}-${s.direction}-${s.id}-${Date.now()}`,
              })}
              title="Show this segment on the map"
            >
              {showAnalysis && <td>{s.analysis}</td>}
              <td>{fmtMp(s.mpStart)}–{fmtMp(s.mpEnd)}</td>
              <td>{s.direction === 'P' ? 'EB' : 'WB'}</td>
              <td>{s.curveNumber != null ? `curve #${s.curveNumber}` : s.nPoints}</td>
              <td>{s.worstValue}</td>
              <td><span className={`safety-sev safety-sev-${s.worstSeverity}`}>{s.worstSeverity}</span></td>
              <td>{s.lengthMi}</td>
              <td>{s.crashCount || '·'}</td>
              <td>{s.nonAnimalCount ? <strong>{s.nonAnimalCount}</strong> : '·'}</td>
              <td>{s.injuryCount || '·'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
